import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerDetailsUnit: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
    },
    containerTypeDetails: {
      display: "flex",
      flexDirection: "row",
      gap: "4px",
    },
    containerFromTO: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      alignItems: "center",
      justifyContent: "center",
    },
    typePriceTitle: {
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.secondary,
      lineHeight: "20px",
    },
    fromToTitle: {
      fontSize: "16px",
      fontWeight: 600,
      color: theme.palette.text.secondary,
      lineHeight: "24px",
    },
    containerUnitModelsView: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
  };
});
